import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6bef8b6c = () => interopDefault(import('../../../pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _467fe330 = () => interopDefault(import('../../../pages/explore/index.vue' /* webpackChunkName: "pages/explore/index" */))
const _6756c994 = () => interopDefault(import('../../../pages/ForgotPassword.vue' /* webpackChunkName: "pages/ForgotPassword" */))
const _b0e0a966 = () => interopDefault(import('../../../pages/galleries/index.vue' /* webpackChunkName: "pages/galleries/index" */))
const _6329f61c = () => interopDefault(import('../../../pages/limiteds/index.vue' /* webpackChunkName: "pages/limiteds/index" */))
const _15e3b6ba = () => interopDefault(import('../../../pages/Login.vue' /* webpackChunkName: "pages/Login" */))
const _fa14c7c0 = () => interopDefault(import('../../../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _172a8d59 = () => interopDefault(import('../../../pages/Register.vue' /* webpackChunkName: "pages/Register" */))
const _880276b2 = () => interopDefault(import('../../../pages/subscribe/index.vue' /* webpackChunkName: "pages/subscribe/index" */))
const _5f2f1e50 = () => interopDefault(import('../../../pages/TestError.vue' /* webpackChunkName: "pages/TestError" */))
const _ce7d6ee2 = () => interopDefault(import('../../../pages/vault/index.vue' /* webpackChunkName: "pages/vault/index" */))
const _98173ca8 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _47f6bd77 = () => interopDefault(import('../../../pages/account/unsubscribe/_id/index.vue' /* webpackChunkName: "pages/account/unsubscribe/_id/index" */))
const _1927b34a = () => interopDefault(import('../../../pages/checkout/_id/index.vue' /* webpackChunkName: "pages/checkout/_id/index" */))
const _2cd857b8 = () => interopDefault(import('../../../pages/galleries/_id/index.vue' /* webpackChunkName: "pages/galleries/_id/index" */))
const _563a8f52 = () => interopDefault(import('../../../pages/reset/_id/index.vue' /* webpackChunkName: "pages/reset/_id/index" */))
const _115011fb = () => interopDefault(import('../../../pages/checkout/_id/success.vue' /* webpackChunkName: "pages/checkout/_id/success" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _6bef8b6c,
    name: "account"
  }, {
    path: "/explore",
    component: _467fe330,
    name: "explore"
  }, {
    path: "/ForgotPassword",
    component: _6756c994,
    name: "ForgotPassword"
  }, {
    path: "/galleries",
    component: _b0e0a966,
    name: "galleries"
  }, {
    path: "/limiteds",
    component: _6329f61c,
    name: "limiteds"
  }, {
    path: "/Login",
    component: _15e3b6ba,
    name: "Login"
  }, {
    path: "/logout",
    component: _fa14c7c0,
    name: "logout"
  }, {
    path: "/Register",
    component: _172a8d59,
    name: "Register"
  }, {
    path: "/subscribe",
    component: _880276b2,
    name: "subscribe"
  }, {
    path: "/TestError",
    component: _5f2f1e50,
    name: "TestError"
  }, {
    path: "/vault",
    component: _ce7d6ee2,
    name: "vault"
  }, {
    path: "/",
    component: _98173ca8,
    name: "index"
  }, {
    path: "/account/unsubscribe/:id",
    component: _47f6bd77,
    name: "account-unsubscribe-id"
  }, {
    path: "/checkout/:id",
    component: _1927b34a,
    name: "checkout-id"
  }, {
    path: "/galleries/:id",
    component: _2cd857b8,
    name: "galleries-id"
  }, {
    path: "/reset/:id",
    component: _563a8f52,
    name: "reset-id"
  }, {
    path: "/checkout/:id?/success",
    component: _115011fb,
    name: "checkout-id-success"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
